import api from '~/utils/api';

export interface FeatureFlagContextData {
  powerBiEmbeddedEnabled: boolean;
  aberturaChamadosEnabled: boolean;
  crudDashboardsPowerBiEmbeddedEnabled: boolean;
  dashboardsPowerBiEmbeddedEnabled: boolean;
  mapaEstrategicoEnabled: boolean;
  parqueMaquinasEnabled: boolean;
  mapaEstrategicoContratosEnabled: boolean;
  abaFinanceiroDetalheContratoEnabled: boolean;
  mapaEstrategicoContratosGraficoCDIEnabled: boolean;
  mapaEstrategicoContratosGraficoIndiceEnabled: boolean;
  mapaEstrategicoContratosGraficoPagAcumuladoEnabled: boolean;
  mapaEstrategicoContratosGraficoDolarEnabled: boolean;
  solicitarRescisaoContratosEnabled: boolean;
  documentosDownloadCSVEnabled: boolean;
  parametrosAnaliseExtensaoAutomaticaEnabled: boolean;
  analiseAutomaticaExtensaoEnabled: boolean;
  abaAnotacoesDetalheContratoEnabled: boolean;
}

export const fetchFeatures = async (): Promise<{
  features: FeatureFlagContextData;
}> => {
  try {
    const res = await api.get<FeatureFlagContextData>('/feature-flags');
    const features = res.data;
    return { features };
  } catch (error) {
    console.error('Erro ao carregar features:', error);
    return { features: {} as FeatureFlagContextData };
  }
};
